import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, TransitionGroup as _TransitionGroup } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  ref: "thumbnailCanvas",
  style: {"position":"fixed","visibility":"hidden","z-index":"-3"}
}
const _hoisted_3 = {
  key: 0,
  class: "file-sortable-handle"
}
const _hoisted_4 = {
  key: "new",
  class: "file-preview-wrapper grid-box-item grid-block file-preview-new"
}
const _hoisted_5 = { class: "file-preview" }
const _hoisted_6 = { style: {"position":"absolute","top":"0","right":"0","bottom":"0","left":"0"} }
const _hoisted_7 = { class: "help-text" }
const _hoisted_8 = ["disabled", "multiple", "accept", "capture"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueFileIcon = _resolveComponent("VueFileIcon")!
  const _component_VueFilePreview = _resolveComponent("VueFilePreview")!
  const _directive_vfa_sortable_handle = _resolveDirective("vfa-sortable-handle")!

  return (_openBlock(), _createElementBlock("div", {
    onDragover: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.dragOver && _ctx.dragOver(...args))),
    onDragenter: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.dragEnter && _ctx.dragEnter(...args))),
    onDragleave: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.dragLeave && _ctx.dragLeave(...args))),
    onDrop: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.drop && _ctx.drop(...args))),
    class: _normalizeClass([
      'is-sortable-' + (_ctx.isSortable ? 'enabled' : 'disabled'),
      {
        'is-sortable-hold': _ctx.sortable === 'hold',
        'is-sortable-handle': _ctx.sortable === 'handle',
        'is-sortable-immediately': _ctx.sortable === true,
        'is-sorting': _ctx.isSorting,
        'is-sorting-active': _ctx.isSortingActive,
        'is-drag-over': _ctx.isDragging,
        'is-disabled': _ctx.disabled === true,
        'is-readonly': _ctx.readonly === true,
        'is-drag-valid': !(_ctx.disabled === true || _ctx.readonly === true || (_ctx.hasMultiple && !_ctx.canAddMore)),
      },
      'theme-' + _ctx.theme,
    ]),
    id: 'vfa-' + _ctx.uniqueId
  }, [
    _renderSlot(_ctx.$slots, "before-outer", {}, undefined, true),
    _createElementVNode("div", {
      class: _normalizeClass(["grid-block-wrapper vue-file-agent file-input-wrapper", {
        'is-compact': !!_ctx.compact,
        'is-single': !_ctx.hasMultiple,
        'has-multiple': _ctx.hasMultiple,
        'no-meta': _ctx.meta === false,
      }])
    }, [
      _renderSlot(_ctx.$slots, "before-inner", {}, undefined, true),
      _createElementVNode("canvas", _hoisted_2, null, 512),
      (_ctx.overallProgress)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["overall-progress", { 'overall-progress-full': _ctx.overallProgress >= 100 }])
          }, [
            _createElementVNode("div", {
              class: "overall-progress-bar",
              style: _normalizeStyle({ width: _ctx.overallProgress + '%' })
            }, null, 4),
            _createElementVNode("div", {
              class: "overall-progress-left",
              style: _normalizeStyle({ width: 100 - _ctx.overallProgress + '%' })
            }, null, 4)
          ], 2))
        : _createCommentVNode("", true),
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.isSortable ? 'vfa-sortable-list' : 'VueFileList'), {
        modelValue: _ctx.fileRecords,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.fileRecords) = $event)),
        axis: _ctx.theme == 'list' ? 'y' : 'xy',
        appendTo: '#vfa-' + _ctx.uniqueId + ' .vue-file-agent',
        transitionDuration: _ctx.transitionDuration,
        pressDelay: _ctx.sortable === 'hold' ? 200 : 0,
        useDragHandle: _ctx.sortable === 'handle',
        onSortStart: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sortStart())),
        onSortEnd: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sortEnd($event))),
        helperClass: 'active-sorting-item'
      }, {
        default: _withCtx(() => [
          _createVNode(_TransitionGroup, {
            name: "grid-box",
            tag: "div",
            class: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileRecords, (fileRecord, index) => {
                return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.isSortable ? 'vfa-sortable-item' : 'VueFileListItem'), {
                  class: "file-preview-wrapper grid-box-item grid-block",
                  index: index,
                  key: fileRecord.id
                }, {
                  default: _withCtx(() => [
                    (_ctx.sortable === 'handle')
                      ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_3, [
                          _renderSlot(_ctx.$slots, "sortable-handle", {}, () => [
                            _createVNode(_component_VueFileIcon, { name: "system-sortable-handle" })
                          ], true)
                        ])), [
                          [_directive_vfa_sortable_handle]
                        ])
                      : _createCommentVNode("", true),
                    _renderSlot(_ctx.$slots, "file-preview", {
                      fileRecord: fileRecord,
                      fileData: fileRecord,
                      index: index
                    }, () => [
                      _createVNode(_component_VueFilePreview, {
                        averageColor: _ctx.averageColor,
                        value: fileRecord,
                        deletable: _ctx.isDeletable,
                        editable: _ctx.editable === true,
                        linkable: _ctx.linkable === true,
                        errorText: _ctx.errorText,
                        disabled: _ctx.disabled,
                        thumbnailSize: _ctx.thumbnailSize,
                        isDuplicateFile: fileRecord.isDuplicateFile,
                        fileCheckUrl: _ctx.fileCheckUrl,
                        onRemove: _cache[0] || (_cache[0] = ($event: any) => (_ctx.removeFileRecord($event))),
                        onRename: _cache[1] || (_cache[1] = ($event: any) => (_ctx.filenameChanged($event))),
                        class: ""
                      }, null, 8, ["averageColor", "value", "deletable", "editable", "linkable", "errorText", "disabled", "thumbnailSize", "isDuplicateFile", "fileCheckUrl"])
                    ], true)
                  ]),
                  _: 2
                }, 1032, ["index"]))
              }), 128)),
              (_ctx.canAddMore && _ctx.readonly !== true)
                ? _renderSlot(_ctx.$slots, "file-preview-new", { key: 0 }, () => [
                    _createElementVNode("label", _hoisted_4, [
                      _createElementVNode("span", _hoisted_5, [
                        _createElementVNode("span", _hoisted_6, [
                          _createVNode(_component_VueFileIcon, { name: "system-file-preview-new" }),
                          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.helpTextComputed), 1)
                        ])
                      ]),
                      _createElementVNode("input", {
                        title: "",
                        ref: "fileInput",
                        disabled: _ctx.disabled === true || (_ctx.hasMultiple && !_ctx.canAddMore),
                        type: "file",
                        multiple: _ctx.hasMultiple,
                        class: "file-input",
                        onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.filesChanged && _ctx.filesChanged(...args))),
                        accept: _ctx.accept || '*',
                        capture: _ctx.capture || undefined
                      }, null, 40, _hoisted_8)
                    ])
                  ], true)
                : _createCommentVNode("", true)
            ]),
            _: 3
          })
        ]),
        _: 3
      }, 40, ["modelValue", "axis", "appendTo", "transitionDuration", "pressDelay", "useDragHandle"])),
      _renderSlot(_ctx.$slots, "after-inner", {}, undefined, true)
    ], 2),
    _renderSlot(_ctx.$slots, "after-outer", {}, undefined, true)
  ], 42, _hoisted_1))
}